import Service from "../../Services";

const FaqCategory = {
  namespaced : true,
  state : {
    form : {
      category_id : '',
      category_name : '',
    }
  },
  mutations : {
    GET_FORM:(state,res)=>{
      state.form = res;
    },
    CLEAR_FORM_DATA :(state)=>{
      state.form = {
        category_id : '',
        category_name : '',
      }
    }
  },
  actions : {
    getFaqCategoryAll({commit}){
      return Service.FaqCategoryAPI.getFaqCategoryAll();
    },
    getFaqCategory({commit},page){
      return Service.FaqCategoryAPI.getFaqCategory(page);
    },
    showFaqCategory({commit},id){
      return Service.FaqCategoryAPI.showFaqCategory(id);
    },
    saveFaqCategory({commit},{id,data}){
      if(id){
        return Service.FaqCategoryAPI.updateFaqCategory(id,data);
      }else{
        return Service.FaqCategoryAPI.createFaqCategory(data);
      }
    },
    deleteFaqCategory({commit},id){
      return Service.FaqCategoryAPI.deleteFaqCategory(id);
    },
    setFormFaqCategory({commit},res){
      commit('GET_FORM',res);
    },
    clearFormData({commit}){
      commit('CLEAR_FORM_DATA');
    }
  },
}
export default FaqCategory
